function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}

export { _arrayWithHoles as default };
